import { render, staticRenderFns } from "./ButtonPostJob.vue?vue&type=template&id=6fea5a58&"
import script from "./ButtonPostJob.vue?vue&type=script&lang=ts&"
export * from "./ButtonPostJob.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BixLink: require('/root/project/frontend/src/components/BixLink.vue').default})
